import type {
    IconDefinition,
    SizeProp,
} from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { DefaultComponentProps } from "@/types/component.types";
import cn from "@/utils/cn";
import styles from "./Icon.module.css";
import type { CustomIcon, IconType } from "./Icon.types";
import icons from "./Icon.types";
import {
    convertLiteralSizingClassToFontSize,
    defaultIconSize,
} from "./Icon.utils";

export interface IconProps extends DefaultComponentProps {
    readonly name: IconType;
    readonly size?: SizeProp;
}

function Icon({ className, name, size = defaultIconSize, testId }: IconProps) {
    const icon: CustomIcon | IconDefinition = icons[name];
    const classNames = cn(styles.icon, className);
    const fontSize = convertLiteralSizingClassToFontSize(size);

    if (typeof icon === "function") {
        const IconComponent = icon;
        const iconIsFlag = name.startsWith("flag");

        return (
            <IconComponent
                className={cn(className, iconIsFlag && styles.flag)}
                data-testid={testId}
                height={fontSize}
                width={fontSize}
            />
        );
    }

    return (
        <FontAwesomeIcon
            className={classNames}
            data-testid={testId}
            icon={icon}
            size={size}
            width={fontSize}
        />
    );
}

Object.defineProperty(Icon, "__isIcon", { value: true, enumerable: false });

export default Icon;
